var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPsychologist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 139.11 139.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff160a;}.cls-2,.cls-3{opacity:0.2;}.cls-3,.cls-4{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.11,70a69.56,69.56,0,1,0-69.57,69.58A69.56,69.56,0,0,0,139.11,70Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.54,128.76A69.56,69.56,0,0,1,.19,64.36C.07,66.07,0,67.8,0,69.54a69.56,69.56,0,1,0,139.11,0c0-1.74-.06-3.47-.19-5.18A69.59,69.59,0,0,1,69.54,128.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M69.54,10.35a69.58,69.58,0,0,1,69.38,64.37c.13-1.71.19-3.44.19-5.18A69.56,69.56,0,0,0,0,69.54c0,1.74.07,3.47.19,5.18A69.55,69.55,0,0,1,69.54,10.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M85.1,53.19a3,3,0,0,1-.59,0,3.26,3.26,0,0,1-2.62-3.79,12.48,12.48,0,0,1,1.72-4.43c3.57-5.67,11.34-7.72,18.9-5a3.26,3.26,0,1,1-2.21,6.13c-4.66-1.69-9.25-.73-11.18,2.32a6.13,6.13,0,0,0-.82,2.13A3.25,3.25,0,0,1,85.1,53.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M69.51,105.07h0a3.27,3.27,0,0,1-3.26-3.27l.12-58.08a3.26,3.26,0,0,1,3.26-3.25h0a3.26,3.26,0,0,1,3.25,3.27l-.12,58.08A3.25,3.25,0,0,1,69.51,105.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M69.51,48.12a3.26,3.26,0,0,1-3.26-3.26c0-8.07-6.15-14.63-13.72-14.63-7.18,0-13.19,6-13.69,13.61a3.26,3.26,0,1,1-6.5-.42c.71-11.05,9.58-19.71,20.19-19.71,11.16,0,20.24,9.49,20.24,21.15A3.26,3.26,0,0,1,69.51,48.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M37,82.5a3.18,3.18,0,0,1-1.54-.39,23,23,0,0,1-8.3-31.75,18.84,18.84,0,0,1,12.74-8.92A3.26,3.26,0,0,1,41,47.85a12.45,12.45,0,0,0-8.36,5.92,16.11,16.11,0,0,0-2,11.4,15.92,15.92,0,0,0,7.82,11.2A3.26,3.26,0,0,1,37,82.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M45.14,104.44h-.23A15.57,15.57,0,0,1,30.67,91.07a15.4,15.4,0,0,1,4.28-13,3.26,3.26,0,1,1,4.66,4.56,8.94,8.94,0,0,0-2.49,7.52,9,9,0,0,0,8.25,7.74,3.26,3.26,0,0,1-.23,6.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M54.44,85A3.29,3.29,0,0,1,52,83.84a8.73,8.73,0,0,0-.85-.87,9,9,0,0,0-12.7.8,3.26,3.26,0,1,1-4.88-4.31,15.52,15.52,0,0,1,21.89-1.38,15.91,15.91,0,0,1,1.47,1.49A3.27,3.27,0,0,1,54.44,85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M48.21,62.07a3.26,3.26,0,0,1-.85-6.4c1.81-.49,3.23-2.54,3.46-5,0-.21,0-.43,0-.64a3.26,3.26,0,0,1,3.26-3.23h0a3.27,3.27,0,0,1,3.23,3.3c0,.39,0,.78-.07,1.18-.49,5.17-3.8,9.45-8.25,10.66A3.1,3.1,0,0,1,48.21,62.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M57.39,115.52A15.46,15.46,0,0,1,42,101.63a3.26,3.26,0,1,1,6.48-.67,9,9,0,0,0,17.84.38,3.25,3.25,0,1,1,6.44,1A15.58,15.58,0,0,1,57.39,115.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M69.89,105a3.26,3.26,0,0,1-3.26-3.26l-.12-58.08a3.25,3.25,0,0,1,3.25-3.26h0A3.25,3.25,0,0,1,73,43.61l.12,58.08A3.26,3.26,0,0,1,69.89,105Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M69.89,46.65a3.26,3.26,0,0,1-3.26-3.26A19.47,19.47,0,0,1,105.54,42a3.26,3.26,0,0,1-6.51.44,12.95,12.95,0,0,0-25.88.92A3.26,3.26,0,0,1,69.89,46.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M99.74,82.5a3.26,3.26,0,0,1-1.24-6.28,16.78,16.78,0,0,0,8-23.71,15.4,15.4,0,0,0-9.63-7.36,3.26,3.26,0,1,1,1.6-6.32,21.91,21.91,0,0,1,13.68,10.43,23.29,23.29,0,0,1-11.21,33A3.23,3.23,0,0,1,99.74,82.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M94.19,104.44A3.26,3.26,0,0,1,94,97.93a9,9,0,0,0,5.77-15.26,3.26,3.26,0,0,1,4.66-4.56,15.41,15.41,0,0,1,4.28,13,15.57,15.57,0,0,1-14.24,13.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M84.37,81.75a3.26,3.26,0,0,1-3.21-2.69c-1.08-6.13,1.71-11.94,6.94-14.47a11.3,11.3,0,0,1,1.31-.54,3.26,3.26,0,1,1,2.15,6.15,6.5,6.5,0,0,0-.61.25,6.76,6.76,0,0,0-3.37,7.48,3.25,3.25,0,0,1-2.65,3.77A3.64,3.64,0,0,1,84.37,81.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M82,116a15.59,15.59,0,0,1-15.34-13.24,3.26,3.26,0,1,1,6.45-.95A9,9,0,0,0,91,101.41a3.26,3.26,0,0,1,6.48.68A15.47,15.47,0,0,1,82,116Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsychologist);
export default __webpack_public_path__ + "static/media/Psychologist.e4caec7aa6fcea25ad3134d9f0cfcd1c.svg";
export { ForwardRef as ReactComponent };